import { createContext } from "react";
const RoomsContext = createContext({});
export default RoomsContext;
